import React from 'react'
import { Col, Image } from 'react-bootstrap'

const ContactUs = () => (
  <Col componentClass="article" mdOffset={2} md={8} xs={12}>
    <h1>Contact Us</h1>
    <p>
      For questions about our service or to report an issue please send us an
      email us at:
      <br />
      <Image
        responsive
        alt="email general support"
        src="https://carfinder.com/assets/img/cfemail_general_support.jpg"
        title=""
      />
    </p>
    <p>
      <span className="cfSectionHeading">
        Please provide the following when reporting an issue:
      </span>
    </p>
    <ul>
      <li>Your Name</li>
      <li>The Date and Time you saw the error</li>
      <li>
        The last 3 steps you performed prior to encountering the issue (as much
        detail as possible)
      </li>
      <li>
        The type of browser you are using and the version number of the browser
      </li>
      <li>Your email address</li>
    </ul>
  </Col>
)
export default ContactUs



// WEBPACK FOOTER //
// ./src/components/ContactUs.js